import React from 'react';
import { Row, Col } from "antd"
import { TextCustom, } from "../../../components/text"
import { StyledContainerBlock } from '../../../components/container/styled';
import { RECOMENDDETAIL } from '../constant';
import { GUTTER_LAYOUT,BREAKE_POINT,MARGINTOP20 } from '../../../resources';
import { color } from '../../../resources';

export const Recommendations = () => {

  return (
    <div style={{ ...MARGINTOP20, textAlign: 'center' }}>
      <TextCustom text={"สิ่งที่ต้องเตรียมสำหรับการขาย"} size={"32px"} color={color.theme} bold />
      <StyledContainerBlock style={{ padding: '20px' }}>
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT} >
          {
            RECOMENDDETAIL().map((el, i) => {
              return <Col {...BREAKE_POINT?.OTHER_COUTENT_ONE} ><div className="space-container" key={`recomend_detail_${i}`}>
                <span className="text-title"><img src={el.icon} /></span>
                <span className="text-detail-recomend"><span style={{ color: color.darkgrey }}>{el.title}</span><br />{el.description}</span>
              </div> </Col>
            })
          }
        </Row>
      </StyledContainerBlock>
    </div>
  )
}

